module.exports = __webpack_public_path__ + "static/img/063.c725269.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/063.jpg
// module id = I2wF
// module chunks = 0